import React from 'react';
import ProductCard from './ProductCard'; 
// Мы больше НЕ импортируем CSS-файл, потому что стили будут прямо здесь

// Вот, сука, сами стили. Мы их вставим прямо в страницу.
// Браузер не сможет это проигнорировать.
const guaranteedStyles = `
  .mobile-product-grid-section {
    padding: 20px 15px;
    background: white;
  }
  
  .mobile-section-header {
    text-align: center;
    margin-bottom: 24px;
  }
  
  .mobile-section-subtitle {
    font-size: 14px;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0 0 8px 0;
  }
  
  .mobile-section-title {
    font-size: 26px;
    font-weight: 700;
    color: #333;
    margin: 0;
  }

  /* === САМАЯ ГЛАВНАЯ, СУКА, ЧАСТЬ === */
  /* Эта хуйня '!important' говорит браузеру: "Мне похуй на все другие стили, делай так!" */
  .mobile-products-container {
    display: flex !important;
    flex-direction: column !important; /* ОДНА КОЛОНКА */
    gap: 25px !important; /* Отступ между карточками */
  }

  /* === СТИЛИ ДЛЯ БЕЙДЖА В МОБИЛЬНОЙ ВЕРСИИ === */
  .showcase-badge {
    background-color: #84cc16 !important;
    color: white !important;
    font-weight: bold !important;
    font-size: 12px !important;
    padding: 4px 12px !important;
    border-radius: 15px !important;
    display: inline-block !important;
    margin-bottom: 8px !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
`;

const MobileProductGrid = ({ title, subtitle, products, onProductClick }) => {
    
    if (!products || products.length === 0) {
        return null; 
    }

    return (
        // Мы вставляем наши стили прямо здесь. Это гарантирует, что они сработают.
        <>
            <style>{guaranteedStyles}</style>
            <section className="mobile-product-grid-section">
                <div className="mobile-section-header">
                    {subtitle && <p className="mobile-section-subtitle">{subtitle}</p>}
                    <h2 className="mobile-section-title">{title}</h2>
                </div>

                <div className="mobile-products-container">
                    {products.map((product) => (
                        <ProductCard
                            key={product.id}
                            product={product}
                            onCardClick={onProductClick}
                        />
                    ))}
                </div>
            </section>
        </>
    );
};

export default MobileProductGrid;